const NoPage = () => <>404 | Page is not found</>;

export default NoPage;
